<template>
  <div class="w-full min-h-screen flex items-center justify-center relative overflow-hidden bg-gradient-to-b from-gray-50 to-white font-sans">
    <!-- grid background pattern -->
    <div class="absolute inset-0 opacity-40 pointer-events-none" style="background-image: linear-gradient(#e5e7eb 1px, transparent 1px), linear-gradient(90deg, #e5e7eb 1px, transparent 1px); background-size: 40px 40px;"></div>

    <!-- animated glow -->
    <div class="absolute top-0 right-0 w-96 h-96 bg-indigo-400/30 rounded-full blur-[100px] pointer-events-none animate-drift"></div>
    <div class="absolute bottom-0 left-0 w-80 h-80 bg-orange-400/20 rounded-full blur-[100px] pointer-events-none animate-drift-reverse"></div>

    <!-- main content -->
    <div class="w-full max-w-[400px] px-6 py-8 relative z-10">
      <!-- logo -->
      <div class="flex flex-col items-center gap-2 mb-8 animate-fade-in">
        <div class="w-14 h-14 bg-gray-900 rounded-[14px] flex items-center justify-center shadow-lg">
         <ImgComponent src="/logo.png" alt="" class="w-full h-full" />
        </div>
        <div class="font-outfit font-bold text-2xl text-gray-900 tracking-tight">1xPay</div>
      </div>

      <!-- feature cards -->
      <div class="flex flex-col gap-3 mb-8 animate-scale-in">
        <div class="feature-card group flex items-center gap-4 p-4 bg-white rounded-2xl border border-gray-200 transition-all duration-300 hover:border-indigo-500 hover:shadow-xl hover:shadow-indigo-500/10 hover:translate-x-1 cursor-pointer">
          <div class="w-11 h-11 rounded-xl bg-emerald-500/10 flex items-center justify-center flex-shrink-0">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2">
              <path d="M12 4v16m0-16l-4 4m4-4l4 4"/>
            </svg>
          </div>
          <div class="flex-1">
            <div class="font-bold text-base text-gray-900">Recharge & Retraits</div>
            <div class="text-sm text-gray-500">Mobile Money</div>
          </div>
          <div class="text-xl text-gray-300 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-indigo-500">→</div>
        </div>

        <div class="feature-card group flex items-center gap-4 p-4 bg-primary rounded-2xl border border-transparent transition-all duration-300 hover:shadow-xl hover:shadow-indigo-500/20 hover:translate-x-1 cursor-pointer">
          <div class="w-11 h-11 rounded-xl bg-white/20 flex items-center justify-center flex-shrink-0">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
              <path d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"/>
            </svg>
          </div>
          <div class="flex-1">
            <div class="font-bold text-base text-white">Échange</div>
            <div class="text-sm text-white/80">Crypto instant</div>
          </div>
          <div class="text-xl text-white/60 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-white">→</div>
        </div>

      </div>

      <!-- stats -->
      <div class="flex justify-center items-center gap-6 p-5 mb-8 bg-white rounded-2xl border border-gray-200 shadow-sm animate-fade-in">
        <div class="text-center">
          <div class="font-outfit font-bold text-xl text-gray-900">50K+</div>
          <div class="text-xs text-gray-500 uppercase tracking-wider">Utilisateurs</div>
        </div>
        <div class="w-px h-8 bg-gray-200"></div>
        <div class="text-center">
          <div class="font-outfit font-bold text-xl text-gray-900">2M+</div>
          <div class="text-xs text-gray-500 uppercase tracking-wider">Transactions</div>
        </div>
        <!-- <div class="w-px h-8 bg-gray-200"></div> -->
        <!-- <div class="text-center">
          <div class="font-outfit font-bold text-xl text-gray-900">4.9</div>
          <div class="text-xs text-gray-500 uppercase tracking-wider">Note</div>
        </div> -->
      </div>

      <!-- bottom -->
      <div class="text-center animate-slide-up">
        <div class="mb-6">
          <h1 class="font-outfit font-extrabold text-3xl text-gray-900 leading-tight tracking-tight">Tes opérations,<br>sans limite</h1>
        </div>

        <div class="mb-6">
          <router-link to="/login" class=" items-center justify-center gap-2 w-full bg-primary buttonComponent flex! text-white rounded-[14px] font-semibold text-base shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300">
            <span>Commencer</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M5 12h14m-4-4l4 4-4 4"/>
            </svg>
          </router-link>
        </div>

        <div class="flex justify-center gap-6">
          <div class="flex items-center gap-1.5 text-sm font-semibold text-gray-500">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-emerald-500">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
            <span>Sécurisé</span>
          </div>
          <div class="flex items-center gap-1.5 text-sm font-semibold text-gray-500">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-indigo-500">
              <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
            </svg>
            <span>Instantané</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');

.font-outfit {
  font-family: 'Outfit', sans-serif;
}

@keyframes drift {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(30px, 20px); }
}

@keyframes drift-reverse {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-30px, 20px); }
}

.animate-drift {
  animation: drift 15s ease-in-out infinite;
}

.animate-drift-reverse {
  animation: drift-reverse 18s ease-in-out infinite;
}

.animate-fade-in {
  animation: fade-in 0.6s ease-out forwards;
}

.animate-scale-in {
  animation: scale-in 0.6s ease-out 0.15s forwards;
  opacity: 0;
}

.animate-slide-up {
  animation: slide-up 0.6s ease-out 0.3s forwards;
  opacity: 0;
}

@keyframes fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scale-in {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes slide-up {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
